// ============================================================
// src/api/timesheetApi.js  –  Timesheet API calls
// ============================================================
// Backend: GET  /api/timesheet/my-week
//          POST /api/timesheet/entries
//          DEL  /api/timesheet/entries/:id
//          POST /api/timesheet/submit/:weekId
//          GET  /api/timesheet/my-history
//          GET  /api/timesheet/all          [supervisor]
//          GET  /api/timesheet/kpis         [supervisor]
//          GET  /api/timesheet/week/:id/entries
//          POST /api/timesheet/review/:weekId
//          POST /api/timesheet/manual-entry
// ============================================================

import { apiFetch } from './apiConfig';

// GET my current week timesheet
// Returns: { week: {...}, entries: [...] }
export async function getMyWeek(weekEnding) {
  return apiFetch(`/timesheet/my-week?week_ending=${weekEnding}`);
}

// POST add a new time entry
export async function addEntry(entryData) {
  return apiFetch('/timesheet/entries', {
    method: 'POST',
    body: entryData,
  });
}

/** Update a single timesheet entry by ID */
// ✅ FIXED — uses apiFetch like everything else (handles auth automatically)
export async function updateEntry(id, data) {
  return apiFetch(`/timesheet/entries/${id}`, {
    method: 'PUT',
    body: data,
  });
}

// DELETE remove a time entry
export async function deleteEntry(entryId) {
  return apiFetch(`/timesheet/entries/${entryId}`, { method: 'DELETE' });
}

// POST submit week for approval
export async function submitWeek(weekId) {
  return apiFetch(`/timesheet/submit/${weekId}`, { method: 'POST' });
}

// GET my timesheet history
// filters: { status, year }
export async function getMyHistory(filters = {}) {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.year) params.append('year', filters.year);
  return apiFetch(`/timesheet/my-history?${params.toString()}`);
}

export async function exportTimesheets(weekEnding, status = '', search = '') {
  let url = `/timesheet/export?format=excel`;   // ← /timesheet not /timesheets
  if (weekEnding) url += `&week_ending=${weekEnding}`;
  if (status)     url += `&status=${status}`;
  if (search)     url += `&search=${encodeURIComponent(search)}`;

  const blob = await apiFetch(url, { responseType: 'blob' });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = `timesheets-${weekEnding || 'export'}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

// GET all timesheets [supervisor]
// filters: { week_ending, status, search }
export async function getAllTimesheets(filters = {}) {
  const params = new URLSearchParams();
  if (filters.week_ending) params.append('week_ending', filters.week_ending);
  if (filters.status) params.append('status', filters.status);
  if (filters.search) params.append('search', filters.search);
  return apiFetch(`/timesheet/all?${params.toString()}`);
}

// GET dashboard KPIs [supervisor]
export async function getKPIs(weekEnding) {
  const q = weekEnding ? `?week_ending=${weekEnding}` : '';
  return apiFetch(`/timesheet/kpis${q}`);
}

// GET all entries for a specific week [supervisor]
export async function getWeekEntries(weekId) {
  return apiFetch(`/timesheet/week/${weekId}/entries`);
}

// POST approve or reject a timesheet [supervisor]
// action: 'APPROVE' | 'REJECT'
export async function reviewTimesheet(weekId, action, notes = '') {
  return apiFetch(`/timesheet/review/${weekId}`, {
    method: 'POST',
    body: { action, notes },
  });
}

// POST add manual entry for a mechanic [supervisor]
export async function addManualEntry(entryData) {
  return apiFetch('/timesheet/manual-entry', {
    method: 'POST',
    body: entryData,
  });
}
